<template>
  <vs-col vs-lg="6" vs-xs="12" class="mb15">
    <label class="lbl" for="">System Category</label>
    <v-select
      label="name"
      @input="onChange"
      v-model="d"
      :value="value"
      :options="options"
    >
    </v-select>
  </vs-col>
</template>

<script>
import rest from "../../../rest.js";
import { API } from "../../../common/constants.js";
export default {
  name: "category",
  props: {
    value: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data: () => ({
    options: [],
    d: "",
  }),
  methods: {
    onChange() {
      this.$emit("input", {
        category: this.$data.d,
        categorySludge: this.$data.d.guid,
      });
    },
  },
  created() {
    rest
      .post(API.GET_CAT, {})
      .then((r) => {
        this.$data.options = r.data.data;
      })
      .catch(() => {});

    this.$events.on("reset", () => {
      this.$data.d = "";
    });
  },
};
</script>
